import { assert } from '../../lib/assert-sidecar'
import { common } from '../../main/common-sidecar'
import { EVoyageCrewCarryCommand } from './multi/voyageMessageCrewCarry'
import { voyageMessageCrewCarry } from './multi/voyageMessageCrewCarry-sidecar'
import { EWeaponCommand } from './multi/voyageMessageWeaponCommand'
import { voyageMessageWeaponCommand } from './multi/voyageMessageWeaponCommand-sidecar'
import { EVoyageCarryableType } from './voyageCarryableData'
import type { IVoyageCrew } from './voyageCrew'
import { voyageCrew } from './voyageCrew-sidecar'
import { voyageCrew_crew } from './voyageCrew_crew-sidecar'
import { voyageSounds } from './voyageSounds-sidecar'
import { voyageTilemap } from './voyageTilemap-sidecar'
import { voyageWebsockets } from './voyageWebsockets-sidecar'

export function crewUpdate(obj: IVoyageCrew) {
  let ds = common.getUpdateDeltaScaled()
  let d = obj.crewState
  assert.notNil(d)

  let useSystemTime = 1
  d.useSystemTimer += ds
  voyageCrew_crew.setProgress(obj, d.useSystemTimer / useSystemTime)
  if (d.useSystemTimer > useSystemTime) {
    d.useSystemTimer -= useSystemTime

    let tHere = voyageTilemap.getSafeIJ(obj)
    if (tHere) {
      let tLauncher = voyageTilemap.getSystemSafeByKey(
        tHere.text3.replace('loader-', 'torpedo-'),
      )
      if (tLauncher) {
        if (tLauncher.system) {
          if (tLauncher.system.ammo > 0) {
            voyageCrew.say(obj, 'Already loaded')
          } else {
            let torpedo = voyageCrew.getItemSafe(
              obj,
              EVoyageCarryableType.Torpedo,
            )
            if (torpedo) {
              if (voyageWebsockets.getIsHost()) {
                voyageMessageWeaponCommand.sendMessageAndImmediatelyExecute({
                  command: EWeaponCommand.Load,
                  systemId: tLauncher.system.id,
                  crewId: obj.id,
                })
                voyageMessageCrewCarry.sendMessageAndImmediatelyExecute({
                  command: EVoyageCrewCarryCommand.Destroy,
                  carryId1: torpedo.id,
                  carryId2: 0,
                  crewId: obj.id,
                  i: obj.i,
                  j: obj.j,
                  type: EVoyageCarryableType.Torpedo,
                })
              }
            } else {
              voyageCrew.say(obj, 'I am not carrying a torpedo')
            }
          }
        }
      }
    }
  }
}
